<template>
  <article class="support-article">
    <h1>{{ article.title }}</h1>
    <div class="content  body-2" v-html="article.content" />

    <div class="helpful">
      <p class="h4">
        Was this article helpful?
      </p>
      <template v-if="feedbackSent">
        <p class="feedback-message">
          Thank you! We appreciate your feedback.
        </p>
      </template>
      <template v-else-if="helpful">
        <button class="btn-primary" @click="sendFeedback">
          Yes
        </button>
        <button class="btn-primary-transparent" @click="helpful = false">
          No
        </button>
      </template>
      <div v-else class="not-helpful-reasons">
        <label v-for="{ id, reason } in reasons" :key="id" :for="`reason${id}`">
          <input
            :id="`reason${id}`"
            v-model="selectedReason"
            type="radio"
            name="reason"
            :value="id"
          >
          {{ reason }}
        </label>

        <button class="btn-primary" :disabled="!selectedReason" @click="sendFeedback">
          Submit
        </button>
      </div>
    </div>
  </article>
</template>

<script>
import global from '@itbpbg/lms-components/src/mixins/global';

const NOT_HELPFUL_REASONS = [
  {
    id: 1,
    reason: 'This isn’t the answer I was looking for.',
  },
  {
    id: 2,
    reason: 'The information is confusing.',
  },
  {
    id: 3,
    reason: 'The information doesn’t solve my problem.',
  },
  {
    id: 4,
    reason: 'The solution doesn’t work.',
  },
];

export default {
  mixins: [global],
  props: {
    article: { type: Object, required: true },
  },
  data: () => ({ helpful: true, selectedReason: null, feedbackSent: false }),
  computed: {
    reasons() {
      return NOT_HELPFUL_REASONS;
    },
  },
  mounted() {
    this.lightBox(this.$el.querySelectorAll('.content'));
  },
  methods: {
    async sendFeedback() {
      if (!this.helpful && !this.selectedReason) {
        return;
      }

      const payload = { helpful: this.helpful };

      if (this.selectedReason) {
        payload.reason = this.selectedReason;
      }

      const response = await this.$axios.$post(`/help-center/articles/${this.article.id}/feedback`, payload).catch(() => false);

      if (response) {
        this.feedbackSent = response;
      }
    },
  },
};
</script>

<style lang="scss">
.support-article {
  p {
    letter-spacing: normal;
    margin: 0 0 var(--spacing-32);
  }

  .content {
    padding-bottom: var(--spacing-90);
    border-bottom: 1px solid var(--main-light-shade-3);

    > * {
      margin: 0 0 var(--spacing-32);

      &:last-of-type {
        margin: 0;
      }
    }

    ul,
    ol {
      padding-top: 0;
      padding-bottom: 0;
      margin: 0 0 var(--spacing-32);

      li {
        padding-bottom: 4px;
        list-style-position: outside;

        strong {
          font-weight: 600;
        }
      }
    }

    img {
      max-width: 100%;
      width: auto;
      height: auto;
    }
  }

  .helpful {
    padding-top: var(--spacing-md);

    .h4 {
      font-size: var(--fs-base);
      font-weight: 400;
      margin: 0;
      margin-bottom: var(--spacing-16);
    }

    button {
      padding: 13px 0;
      width: 84px;
    }

    .btn-primary-transparent {
      margin-left: 12px;
    }

    .feedback-message {
      font-size: 14px;
    }
  }

  .not-helpful-reasons {
    label {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: normal;
      margin-bottom: var(--spacing-sm);

      input {
        width: 16px;
        height: 16px;
        margin-right: var(--spacing-sm);
      }

      input[type='radio'] {
        -webkit-appearance: none;
        min-width: 16px;
        min-height: 16px;
        border: 1.5px solid var(--main-light-shade-4);
        border-radius: 50%;
        outline: none;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 0;
      }

      input[type='radio']:before {
        content: '';
        width: 8px;
        height: 8px;
        border-radius: 50%;
      }

      input[type='radio']:checked:before {
        background: var(--accent);
      }
    }

    .btn-primary {
      padding-left: 1.3em;
      padding-right: 1.3em;
      margin-left: 5px;
    }
  }

  @include bp($bp-laptop) {
    .content {
      img {
        width: 100%;
        height: 50%;
      }
    }
  }

  @media (max-width: 908px) {
    .content {
      img {
        width: 100%;
        height: 50%;
      }

      @media (max-width: 768px) {
        .content {
          padding-bottom: 40px;
        }
      }
    }
  }

  @include bp($bp-phone) {
    p {
      font-weight: 400;
      font-size: 14px;
      line-height: 130%;
    }
  }

  .fa {
    .not-helpful-reasons label input[type="radio"] {
      min-width: 16px;
      min-height: 16px;
    }
  }
}
</style>
